module.exports = __webpack_public_path__ + "img/style_6_en.a1809091.jpeg";